import { Component, OnInit } from '@angular/core';
import { CmsService } from '../services/cms.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  data: any;
  title: any;
  description: any;
  check_title: any;
  constructor(
    private cmsservice: CmsService,
    private ngxLoader: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    this.ngxLoader.start();
    this.cmsservice.privacyctivedata().subscribe((res: any) => {
      console.log(res);
      this.ngxLoader.stopAll();
      if (res.status == true) {
        this.data = res.privacypolicy;
        if (this.data.length != 0) {
          console.log(this.data);
          let lang = window.localStorage.getItem('app_language');
          if(lang == 'fr'){
            this.title = this.data[0].privacypolicy_data_french;
            this.description = this.data[0].privacypolicy_description_french;
          }else{
            this.title = this.data[0].privacypolicy_data;
            this.description = this.data[0].privacypolicy_description;
          }
          console.log(this.title);
        } else {
          this.check_title = 'no';
        }
      } else {
        this.check_title = 'no';
      }
    }, error => {
      this.ngxLoader.stopAll();
      this.check_title = 'no';
      console.error(error);
    });
  }

}
